import { FunctionComponent, useEffect, useRef, useState } from 'react'
import useStyles from './styles'
import { LayoutActionBarProps } from './types'
import { Button, Grid, Space, Stack, Tooltip } from '@conexasaude/conexa-hero'
import useBreakpoints from '@/utils/useBreakpoints'
import { RenderIf } from '@/components/RenderIf'

export const LayoutActionBar: FunctionComponent<LayoutActionBarProps> = ({
  primaryActionTooltip,
  secondaryActionTooltip,
  negativeActionTooltip,
  primaryActionLabel,
  secondaryActionLabel,
  negativeActionLabel,
  primaryActionProps,
  secondaryActionProps,
  negativeActionProps,
  primaryAction,
  secondaryAction,
  negativeAction,
  hasPrimaryAction,
  hasSecondaryAction,
  hasNegativeAction,
  customContent,
  styles,
}) => {
  const { isPhone } = useBreakpoints()
  const [footerSize, setFooterSize] = useState<number>(undefined)
  const defaultStyles = useStyles({ footerSize })
  const layoutActionBarRef = useRef(null)

  const updateFooterSize = () => {
    if (layoutActionBarRef.current) {
      setFooterSize(layoutActionBarRef.current.clientHeight)
    }
  }

  useEffect(() => {
    updateFooterSize()
  }, [isPhone])

  return (
    <div css={defaultStyles.root} style={styles?.root} ref={layoutActionBarRef}>
      <div css={defaultStyles.container} style={styles?.body}>
        {!isPhone ? (
          <Grid gutter={0} align="center" justify="space-between">
            <Grid.Col span={4}>
              <RenderIf condition={hasSecondaryAction}>
                <Tooltip
                  disabled={!secondaryActionTooltip}
                  label={secondaryActionTooltip}
                  withArrow
                >
                  <Button
                    onClick={secondaryAction}
                    variant="tertiary"
                    {...secondaryActionProps}
                  >
                    {secondaryActionLabel}
                  </Button>
                </Tooltip>
              </RenderIf>
            </Grid.Col>

            <Grid.Col span={8}>
              <Grid justify="end" gutter={0}>
                <RenderIf condition={hasNegativeAction}>
                  <Tooltip
                    disabled={!negativeActionTooltip}
                    label={negativeActionTooltip}
                    withArrow
                  >
                    <Button
                      variant="secondary"
                      onClick={negativeAction}
                      {...negativeActionProps}
                    >
                      {negativeActionLabel}
                    </Button>
                  </Tooltip>
                </RenderIf>

                <RenderIf condition={hasNegativeAction && hasPrimaryAction}>
                  <Space w="md" />
                </RenderIf>

                <RenderIf condition={hasPrimaryAction}>
                  <Tooltip
                    disabled={!primaryActionTooltip}
                    label={primaryActionTooltip}
                    withArrow
                  >
                    <Button onClick={primaryAction} {...primaryActionProps}>
                      {primaryActionLabel}
                    </Button>
                  </Tooltip>
                </RenderIf>
              </Grid>
            </Grid.Col>
          </Grid>
        ) : (
          <Stack>
            <RenderIf condition={hasPrimaryAction}>
              <Tooltip
                disabled={!primaryActionTooltip}
                label={primaryActionTooltip}
                withArrow
              >
                <Button
                  onClick={primaryAction}
                  fullWidth
                  {...primaryActionProps}
                >
                  {primaryActionLabel}
                </Button>
              </Tooltip>
            </RenderIf>

            <RenderIf condition={hasNegativeAction}>
              <Tooltip
                disabled={!negativeActionTooltip}
                label={negativeActionTooltip}
                withArrow
              >
                <Button
                  variant="secondary"
                  onClick={negativeAction}
                  fullWidth
                  {...negativeActionProps}
                >
                  {negativeActionLabel}
                </Button>
              </Tooltip>
            </RenderIf>

            <RenderIf condition={hasSecondaryAction}>
              <Tooltip
                disabled={!secondaryActionTooltip}
                label={secondaryActionTooltip}
                withArrow
              >
                <Button
                  variant="tertiary"
                  onClick={secondaryAction}
                  fullWidth
                  {...secondaryActionProps}
                >
                  {secondaryActionLabel}
                </Button>
              </Tooltip>
            </RenderIf>
          </Stack>
        )}
        {customContent}
      </div>
    </div>
  )
}
